// @ts-nocheck
/* eslint-disable */
export class NullItemID {}
NullItemID.NULL_22938 = 22938
NullItemID.NULL_22939 = 22939
NullItemID.NULL_22940 = 22940
NullItemID.NULL_23044 = 23044
NullItemID['__class'] = 'timetracking.NullItemID'
